<div class="row">
    <div class="col-12 chart-container">
        <div class="row no-gutters chart-columns">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 chart-column column-repair text-center">
                <div #repairGraph class="fill"><hr #repairGraphSeparator class="column-repair-separator" /></div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 chart-column column-replacement text-center">
                <div #replacementGraph class="fill"></div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 chart-column column-salvage text-center">
                <div #salvageGraph class="fill"></div>
            </div>
        </div>

        <div class="row chart-labels">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 column-label text-center">
                {{ 'detailed_processing.results.graphic.label.repair' | translate }} ({{ columns.repair.label }}%)
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 column-label text-center">
                {{ 'detailed_processing.results.graphic.label.replacement' | translate }} ({{ columns.replacement.label }}%)
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 column-label text-center">
                {{ 'detailed_processing.results.graphic.label.salvage' | translate }} ({{ columns.salvage.label }}%)
            </div>
        </div>
    </div>
</div>
